import React from "react";
import PropTypes from "prop-types";
import InputWrapper from "../InputWrapper";
import style from "../../../assets/css/styles.module.scss";

const File = ({
  errorMsg,
  placeholder,
  className,
  value,
  options,
  isValid,
  onChange,
  id,
  name,
  label,
  afterInputText
}) => {
  const applyChange = ev => {
    const event = {
      target: { value: ev.target.files[0] }
    };
    onChange(event);
  };

  const errorClass = isValid === false ? style.inputError : "";
  return (
    <div className={style.uiKitFileWrapper}>
      <InputWrapper
        className={className}
        isValid={isValid}
        errorMsg={errorMsg}
        label={label}
        afterInputText={afterInputText}
      >
        <div className={`${style.inputGroup} ${style.fileGroup}`}>
          <div className={`${style.customFile} ${style.customInputFile}`}>
            <input
              type="file"
              id={id}
              name={name}
              className={`${style.customFileInput} ${errorClass}`}
              {...options}
              onChange={applyChange}
            />
            <label className={`${style.customFileLabel} ${errorClass}`}>
              <span>{value ? value.name : placeholder || ""}</span>
            </label>
          </div>
          {value && (
            <a
              href={value.downloadPath}
              download={value.name}
              className={`${style.downloadLink} ${style.customFileLink}`}
            >
              {value.name}
            </a>
          )}
        </div>
      </InputWrapper>
    </div>
  );
};

File.displayName = "File";

File.defaultProps = {
  id: "",
  name: "",
  errorMsg: null,
  onChange: () => {},
  placeholder: null,
  className: null,
  value: null,
  options: null,
  isValid: null,
  label: null,
  afterInputText: null
};

File.propTypes = {
  /** File id */
  id: PropTypes.string,
  /** File id */
  name: PropTypes.string,
  /** Add any html attributes to the component */
  options: PropTypes.object,
  /** Change event callback */
  onChange: PropTypes.func,
  /** Input value */
  value: PropTypes.object,
  /** File validation error message */
  errorMsg: PropTypes.string,
  /** File placeHolder */
  placeholder: PropTypes.string,
  /** Add className to the component */
  className: PropTypes.string,
  /** Is File valid */
  isValid: PropTypes.bool,
  /** If provided, will add label before the input */
  label: PropTypes.string,
  /** If provided, will add text after the input */
  afterInputText: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default File;
